import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";

const StatusUpdatePopup = ({ visaRequest, onSave, onClose }) => {
  const [status, setStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visaRequest) {
      setStatus(visaRequest.visaRequestStatus || "");
      setPaymentStatus(visaRequest.paymentStatus || "");
    }
  }, [visaRequest]);

  const handleSave = async () => {
    if (!visaRequest) return;

    setIsLoading(true);
    try {
      const statusData = {
        visaRequestStatus: status,
        paymentStatus: paymentStatus,
      };

      console.log("Sending status data:", statusData);

      // Updated URL to match the new endpoint
      const url = `${config.UPDATEVISASTATUS}/${visaRequest.visaRequestId}`;

      // Use PUT method with request body
      const response = await apiService.put(url, statusData);

      console.log("API response:", response);

      if (response && response.success) {
        onSave(); // Notify parent component to refresh data
        onClose(); // Close the popup
      } else {
        throw new Error(response?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert(`Error updating status: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const statusOptions = [
    "NEW",
    "PENDING",
    "PROCESSING",
    "SUBMITTED",
    "APPROVED",
    "REJECTED",
    "DOCUMENTS_MISSING",
    "DOCUMENT_PENDING",
  ];

  const paymentStatusOptions = [
    "PAID",
    "PENDING",
    "FAILED",
    "CANCELLED",
    "REFUNDED",
  ];

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Status</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Visa Status</label>
              <select
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                disabled={isLoading}
              >
                <option value="">Select Status</option>
                {statusOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Payment Status</label>
              <select
                className="form-select"
                value={paymentStatus}
                onChange={(e) => setPaymentStatus(e.target.value)}
                disabled={isLoading}
              >
                <option value="">Select Payment Status</option>
                {paymentStatusOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdatePopup;
